/**
 * True when the pool is a CL farm (Ichi, Gamma, Fertilizer, Steer). Used for routing to /liquidity/cl-farms.
 */
export const isClFarmDisplayType = (displayType: string): boolean => {
  const t = displayType.toLowerCase()
  return t.includes("ichi") || t.includes("gamma") || t.includes("fertilizer") || t.includes("steer")
}

/**
 * Maps full displayType strings to short badge names (e.g. for pool cards).
 * Use for the small top-right badge only; show the raw displayType for the subtitle.
 */
export const getDisplayTypeShortName = (displayType: string): string => {
  switch (displayType) {
    case "Classic Constant Product AMM":
      return "vAMM"
    case "Classic Stableswap 2pool":
      return "sAMM"
    case "Fertilizer ALM on E3 AMM":
      return "Fertilizer"
    case "Gamma ALM on Thick AMM":
    case "Gamma ALM on 2Thick AMM":
      return "Gamma"
    case "Ichi ALM on Thick AMM":
    case "Ichi ALM on 2Thick AMM":
      return "Ichi"
    case "Steer ALM on Thick AMM":
      return "Steer"
    default:
      return displayType
  }
}

export const showDisplayType = (displayType: string, isMobile: boolean, isTablet: boolean) => {
  switch (displayType) {
    case "Classic Constant Product AMM": {
      if (isMobile || isTablet) {
        return "Classic vAMM"
      }
      break
    }
    case "Classic Stableswap 2pool": {
      if (isMobile || isTablet) {
        return "Classic sAMM"
      }
      break
    }
    case "Fertilizer ALM on E3 AMM": {
      if (isMobile || isTablet) {
        return "Fertilizer - E3 AMM"
      }
      break
    }
    case "Gamma ALM on Thick AMM": {
      if (isMobile || isTablet) {
        return "Gamma - Thick AMM"
      }
      break
    }
    case "Gamma ALM on 2Thick AMM": {
      if (isMobile || isTablet) {
        return "Gamma - 2Thick AMM"
      }
      break
    }
    case "Ichi ALM on Thick AMM": {
      if (isMobile || isTablet) {
        return "Ichi - Thick AMM"
      }
      break
    }
    case "Ichi ALM on 2Thick AMM": {
      if (isMobile || isTablet) {
        return "Ichi - 2Thick AMM"
      }
      break
    }
    case "Steer ALM on Thick AMM": {
      if (isMobile || isTablet) {
        return "Steer - Thick AMM"
      }
      break
    }
  }

  return displayType
}
